import React, { useState, useEffect, useRef } from "react";
import Button from '../../button/button_v2';
import { Container } from "react-grid-system";
import Input from "../../input/input_v2";
import { FormContainer, Label, Loading } from "./styles";
import { FormButtonContainer } from "./styles";
import { store } from "react-notifications-component";
import ModalNew from "../../modal/modal";
import ModalText from "../../modal/modalText";
import api from '../../../services/api';
import ModalPassword from '../../modal/modal_password';
import ModalAlert from '../../modal/modalGeneric';
import Modal from '../../modal';
import { ModalBody, ModalTitle } from '../../modal/styles';
import validadorCpfCnpj from "../../../services/validadorCpfCnpj";
import { logout } from "../../../services/auth";
import InputSign from "../../inputSign";
import DragDropUpload from "../../../components/drag-drop-upload/index"
import SignatureTypeCards from "../../signatureTypeCards";
import PlanilhaDropzone, { formatFileSize } from "../../planilha-dropzone";

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
export const USER = "@userinfo";

// Certificado A1: o navegador nem sempre preenche o mime do .pfx/.p12, entao as
// extensoes entram junto para o arquivo nao ser rejeitado na selecao.
const CERTIFICADO_ACCEPT = {
    "application/x-pkcs12": [".pfx", ".p12"],
};

const Agronomo = ({ ...props }) => {
    const { next, update, nome, cpf, isModal, email } = props;

    const [load, setLoad] = useState(false);
    const [nomeId, setNomeId] = useState(nome);
    const [cpfId, setCpfId] = useState(cpf);
    const [disabled, setDisabled] = useState(true);
    const [emailAgronomo, setEmail] = useState(email);
    const [sendEmail, setSendEmail] = useState(false);

    let [soma, setSoma] = useState('');
    let [resto, setResto] = useState('');
    let [teste, setTeste] = useState(true);

    const [cpfValido, setCpfValido] = useState(false);
    const cpfCheckRef = useRef(0);
    const [addModalShow, setAddModalShow] = useState(false);
    const [file, setFile] = useState([]);
    const [namesfiles, setNamesfiles] = useState([]);
    const [textFile, setTextFile] = useState('');
    const [isValidate, setIsValidate] = useState(false);
    const [password, setPassword] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalText, setShowModalText] = useState(false);

    const [erroCpf, setErroCpf] = useState(false);
    const [erroCpfMsg, setErroCpfMsg] = useState(false);

    const [erroNome, setErroNome] = useState(false);
    const [erroNomeMsg, setErroNomeMsg] = useState('Informe o nome do responsável');

    const [erroEmail, setErroEmail] = useState(false);
    const [erroEmailMsg, setErroEmailMsg] = useState('');

    const [showModalBlock, setShowModalBlock] = useState(false);
    const [digital, setDigital] = useState(false);
    const [eletronica, setEletronica] = useState(false);
    const [manual, setManual] = useState(false);

    const [allowedSignatures, setAllowedSignatures] = useState(["M", "D", "E"]);
    const [isLoadingSignTypes, setIsLoadingSignTypes] = useState(true);
    const [uploadCertModal, setUploadCertModal] = useState(false);
    // Arquivo escolhido no dropzone, ainda nao enviado: so vira certificado
    // quando o usuario confirma no "Salvar".
    const [certificadoSelecionado, setCertificadoSelecionado] = useState(null);
    const [signatureModal, setSignatureModal] = useState(false);

    const [sign, setSign] = useState('');

    const [disabledNext, setDisabledNext] = useState(false);
    const [showDisabledCad, setShowDisabledCad] = useState(false);

    const [whatsapp, setWhatsapp] = useState('');
    const [erroWhatsapp, setErroWhatsapp] = useState(false);
    const [erroWhatsappMessage, setErroWhatsappMessage] = useState('Informe um número válido');


    const validateNome = nomeId => {
        setNomeId(nomeId);
        setErroNome(false);
    };

    const validateEmail = emailId => {
        setEmail(emailId);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
        const isValidEmail = emailRegex.test(emailId);

        setErroEmail(!isValidEmail);
        setErroEmailMsg(!isValidEmail ? "Informe um e-mail!" : "");

        return isValidEmail;
    };

    const validateCpf = async (cpfId) => {
        setCpfId(cpfId);

        if (cpfId) {

            if (cpfId.length === 14) {
                const checkId = ++cpfCheckRef.current;
                const resultado = await validadorCpfCnpj(cpfId);
                if (checkId !== cpfCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                setCpfValido(resultado.valido);

                if (!resultado.valido) {
                    setErroCpf(true);
                    setErroCpfMsg(resultado.erro || 'Informe um CPF válido!');
                } else {
                    setErroCpf(false);

                }
            } else {
                setCpfValido(false);
                setErroCpf(false);
            }
        } else {
            setCpfValido(false);
            setErroCpf(false);
        }

    };

    const validateWhatsapp = (numero) => {
        const valor = numero || '';
        const telefoneNumeros = valor.replace(/\D/g, '');

        if (!telefoneNumeros.length) {
            setErroWhatsapp(false);
            setErroWhatsappMessage('');
            return true;
        }

        const isValidTelefone = telefoneNumeros.length === 10 || telefoneNumeros.length === 11;

        setErroWhatsapp(!isValidTelefone);
        setErroWhatsappMessage(!isValidTelefone ? 'Informe um número válido' : '');

        return isValidTelefone;
    };

    const changeWhatsapp = (value) => {
        setWhatsapp(value);
        validateWhatsapp(value);
    };

    const validaFields = e => {
        if (nomeId) {
            if (cpfValido === false) {
                setErroCpf(true);
                setErroCpfMsg('CPF inválido');
                store.addNotification({
                    title: "Erro!",
                    message: "CPF inválido",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                setErroCpf(false);
            }
        } else {
            if (cpfValido === false) {
                setErroCpf(true);
                setErroCpfMsg('CPF inválido');
                store.addNotification({
                    title: "Erro!",
                    message: "CPF inválido",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                setErroCpf(false);
            }
        }
    };

    const addModalClose = () => {
        // e.preventDefault();
        setAddModalShow(false);
    };

    const modalTextClose = () => {
        setShowModalText(false);
    }

    const closeModalPassword = () => {
        setShowModal(false);
        setPassword('');
        setNamesfiles([]);
        setNamesfiles([]);
        setTextFile('');
        setIsValidate(false);
    }

    const nextStep = async e => {
        const isTelephoneValid = validateWhatsapp(whatsapp);

        if (!nomeId || !emailAgronomo || !cpfId || !isTelephoneValid) {
            store.addNotification({
                title: "Erro!",
                message: `Verifique os campos em vermelho`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }

        if (!nomeId) {
            setErroNome(true);
        }

        const isEmailValid = validateEmail(emailAgronomo);

        if (!isEmailValid) {
            setErroEmail(true);
            setErroEmailMsg("Informe um e-mail!");
            store.addNotification({
                title: "Erro!",
                message: "E-mail inválido",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        if (!cpfId) {
            setErroCpf(true);
            setErroCpfMsg("Informe um CPF");
        }
        if (cpfValido == false) {
            store.addNotification({
                title: "Erro!",
                message: `CPF inválido`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } 
              
        if (!isTelephoneValid) {
            setErroWhatsapp(true);
            store.addNotification({
                title: "Erro!",
                message: "Número inválido",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        else {
            if (nomeId && isEmailValid && cpfId && isTelephoneValid) {
                setErroNome(false);
                setErroEmail(false);
                setErroCpf(false);
                setErroWhatsapp(false);
                update(nomeId, cpfId, namesfiles && isValidate ? true : false, sign, emailAgronomo, sendEmail, whatsapp);
                next();
            }
        }
    };

    const validaCertificado = async (file, password) => {
        if (cpfId) {
            if (file && !isValidate && password) {
                const payload = {
                    certificado: file,
                    cpf: cpfId,
                    senha: password,
                }
                try {

                    let user = JSON.parse(localStorage.getItem(USER));
                    if (user.contrato) {
                        if (user.contrato.agro_plan_functions) {
                            let isBlock = false;

                            user.contrato.agro_plan_functions.map((e) => {
                                console.log(e);

                                if (e.agro_plans_function.id === 9) {
                                    if (e.status === 0) {
                                        isBlock = true;
                                    }
                                }
                            });

                            if (isBlock === true) {
                                closeModalPassword();
                                store.addNotification({
                                    title: "Erro!",
                                    message: `A função de assinatura digital não está liberada para seu plano!`,
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                            } else {
                                const response = await api.post(`/sign/digital`, payload);
                                if (response) {
                                    setIsValidate(true);
                                }
                                const input = document.getElementById('cpfId');
                                input.classList.remove("error");
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `${response.data.data.msg}`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                            }

                        } else {
                            logout();
                            window.location = '/login';
                        }
                    } else {
                        logout();
                        window.location = '/login';
                    }


                } catch (error) {
                    closeModalPassword();
                    store.addNotification({
                        title: "Erro!",
                        message: identifyErrorMenssage(error),
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            }
        } else {
            const input = document.getElementById('cpfId');
            input.classList.add("error");

            store.addNotification({
                title: "Erro!",
                message: `Informe o CPF!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    const notificaErro = (mensagem) => {
        store.addNotification({
            title: "Erro!",
            message: mensagem,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
    };

    // Recebe o File escolhido no dropzone (antes vinha o evento do <input>).
    const onChangeCertificate = (arquivo) => {
        let user = JSON.parse(localStorage.getItem(USER));

        if (user.contract_software_id === 6) {
            //Abrir modal de bloqueio
            setShowModalBlock(true);
        } else {
            if (arquivo) {
                // O dropzone ja filtra pelo accept; a checagem fica porque o
                // navegador as vezes manda o .pfx sem mime nenhum.
                const extensaoValida = /\.(pfx|p12)$/i.test(arquivo.name || "");

                if (arquivo.type === "application/x-pkcs12" || extensaoValida) {
                    let reader = new FileReader();
                    reader.readAsDataURL(arquivo);

                    reader.onload = (e) => {
                        setFile(e.target.result);
                        setTextFile(e.target.result);

                        if (cpfId) {
                            setShowModal(true);
                        } else {
                            const input = document.getElementById('cpfId');
                            input.classList.add("error");
                            notificaErro(`Informe o CPF!`);
                        }
                    }
                    setNamesfiles(arquivo.name);

                } else {
                    notificaErro(`O arquivo selecionado não possui a extensão correta`);
                }
            } else {
                notificaErro(`Selecione um arquivo para enviar.`);
            }
        }

    };

    const deleteFile = () => {
        setNamesfiles([]);
        setIsValidate(false);
    };

    // Fechar o modal descarta o que estava escolhido: o arquivo so conta depois
    // do "Salvar", senao reabrir o modal mostraria um certificado que nunca foi
    // enviado.
    const fecharUploadCertModal = () => {
        setUploadCertModal(false);
        setCertificadoSelecionado(null);
    };

    const salvarCertificadoSelecionado = () => {
        if (!certificadoSelecionado) return;

        const arquivo = certificadoSelecionado;
        fecharUploadCertModal();
        onChangeCertificate(arquivo);
    };

    const updatePassword = (e) => {
        validaCertificado(file, e);
        setShowModal(false);
    }

    const openModalText = () => {
        setShowModalText(true);
    }

    const saveSign = (e) => {
        setSign(e);
    }

    const tipoAssinatura = (e) => {
        if (e === 'E') {
            setEletronica(true)
            setDigital(false)
            setManual(false)
        } else if (e === 'D') {
            setDigital(true)
            setManual(false)
            setEletronica(false)
        } else {
            setManual(true)
            setEletronica(false)
            setDigital(false)
        }

    };

    const validaLimite = async () => {

        try {
            const response = await api.get('/agronomos/limite');

            if (response) {

            }
        } catch (error) {
            console.log("ERRO")
            setDisabledNext(true);
            setShowDisabledCad(true);
            // store.addNotification({
            //     title: "Erro!",
            //     message: `${error.response.data.errors}`,
            //     type: "danger",
            //     insert: "top",
            //     container: "top-right",
            //     animationIn: ["animated", "fadeIn"],
            //     animationOut: ["animated", "fadeOut"],
            //     dismiss: {
            //         duration: 4000,
            //         onScreen: true
            //     }
            // });
        }

    }

    const estadoValue = typeof props.estado === "object" ? props.estado?.value : props.estado;

    useEffect(() => {
        const loadAllowedSignatures = async () => {
            setIsLoadingSignTypes(true);
            try {
                if (estadoValue) {
                    const response = await api.get(`/sign/estado/${estadoValue}`);
                    const tipos = response.data.data;
                    let tipo = [];
                    if (tipos.manual === true) tipo.push('M');
                    if (tipos.digital === true) tipo.push('D');
                    if (tipos.eletronica === true) tipo.push('E');
                    setAllowedSignatures(tipo);
                } else {
                    setAllowedSignatures(['M', 'D', 'E']);
                }
            } catch (error) {
                setAllowedSignatures(['M', 'D', 'E']);
            } finally {
                setIsLoadingSignTypes(false);
            }
        };
        loadAllowedSignatures();
    }, [estadoValue]);

    useEffect(() => {
        if (cpfValido == false) {
            setDisabled(true);
        } else {
            if (!nomeId || !cpfId) {
                setDisabled(true);
            } else {
                setDisabled(false);
            }
        }
    }, [nomeId, cpfId]);

    useEffect(() => {
        let cpf = cpfId.replace('___', '');
        cpf = cpf.replace('__', '');
        cpf = cpf.replace('.', '');
        cpf = cpf.replace('-', '');
        cpf = cpf.replace('.', '');
        cpf = cpf.replace('_____', '');
        cpf = cpf.replace('____', '');
        cpf = cpf.replace('___', '');
        cpf = cpf.replace('__', '');
        cpf = cpf.replace('_', '');
        if (cpf.length == 11) {
            if (cpfValido) {
                if (!isValidate) {
                    if (file.length > 0) {
                        if (!password) {
                            setShowModal(true);
                        }
                    }
                }
            }
        }
    }, [cpfId]);

    useEffect(() => {
        if (load === false) {
            setLoad(true);
            validaLimite();
        }

        return () => {}
    }, [])


    const back = () => {
        props.propsLocation.history.goBack();
    }

    const hasSign = typeof sign === "string" && sign.length > 0;
    const hasCertificado = namesfiles.length > 0;
    const selectedMetodo = manual ? "M" : eletronica ? "E" : digital ? "D" : "";

    return (
        <>
            <FormContainer isModal={props.isModal} wide>
                <Container style={{ width: '100%', paddingLeft: props.isModal ? '15px' : '15px', paddingRight: props.isModal ? '15px' : '15px' }}>
                    <form>
                        <div style={{ width: "100%", maxWidth: "400px", display: "flex", flexDirection: "column", gap: "16px" }}>
                        <Input
                            marginBottom="0"
                            minHeight="0px"
                            height="auto"
                            name="nome"
                            type="text"
                            label="Nome"
                            labelWithAsterisk={true}
                            id="nomeId"
                            onChange={e => validateNome(e)}
                            erro={erroNome}
                            messageErro={erroNomeMsg}
                            value={nomeId}
                        />

                        <Input
                            marginBottom="0"
                            minHeight="0px"
                            label="E-mail"
                            labelWithAsterisk={true}
                            name="email"
                            className="input"
                            id="email"
                            onChange={e => validateEmail(e)}
                            yesNo={true}
                            messageYesNo={'enviar receitas por email'}
                            erro={erroEmail}
                            yesNoSpanWidth={'80px'}
                            messageErro={erroEmailMsg}
                            value={emailAgronomo}
                            onChangeYesNo={(e) => setSendEmail(e ? 1 : 0)}
                        />

                        <Input
                            marginBottom="0"
                            minHeight="0px"
                            height="auto"
                            name="cpf"
                            type="text"
                            label="CPF"
                            labelWithAsterisk={true}
                            id="cpfId"
                            value={cpfId}
                            onChange={e => validateCpf(e)}
                            onBlur={(e) => validaFields(e.target.value)}
                            maxlength={14}
                            erro={erroCpf}
                            messageErro={erroCpfMsg}
                            inputmode="numeric"
                        />

                        <Input
                            marginBottom="0"
                            minHeight="0px"
                            height="auto"
                            id="telefone"
                            label="Whatsapp"
                            labelWithAsterisk={false}
                            name="telefonecelular"
                            value={whatsapp}
                            onChange={e => changeWhatsapp(e)}
                            erro={erroWhatsapp}
                            messageErro={erroWhatsappMessage}
                            inputmode="numeric"
                        />
                        </div>

                        {isLoadingSignTypes ? (
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '14px' }}>
                                <Loading />
                            </div>
                        ) : (
                            <SignatureTypeCards
                                value={selectedMetodo}
                                onChange={(type) => tipoAssinatura(type)}
                                allowedSignatures={allowedSignatures}
                                estadoValue={estadoValue}
                                hasElectronicCredential={hasSign}
                                hasDigitalCredential={hasCertificado}
                                namePrefix="card_radio_assinatura_agronomo"
                                responsavelNome={nomeId}
                                onUploadCertificado={() => setUploadCertModal(true)}
                                onCadastrarAssinatura={() => setSignatureModal(true)}
                            />
                        )}
                        
                    </form>
                </Container>

                <div
                    className="button-finish"
                    style={{
                        width: '100%',
                        display: 'flex',
                    }}
                >

                    {isModal ? (null) : (
                        <div className="voltar" id='back'>
                            <Button
                                width='100%'
                                height='50px'
                                value='VOLTAR'
                                outline={true}
                                disabled={false}
                                onClick={() => back()}
                                loading={false}
                            />

                        </div>
                    )}


                    <div className="cadastrar" id='save'>
                        <Button
                            width='100%'
                            height='50px'
                            value='CADASTRAR CREA/CFTA'
                            outline={false}
                            disabled={disabledNext}
                            onClick={() => nextStep()}
                            loading={false}
                        />
                    </div>

                </div>
            </FormContainer>

            <FormButtonContainer>
                <ModalNew
                    title={'CADASTRO'}
                    text={"É necessário adicionar um CREA/Visto para cadastrar um responsável técnico."}
                    show={addModalShow}
                    onHide={() => addModalClose()}
                />
                <ModalPassword
                    text={"Precisamos da sua senha para validar a autenticidade do certificado. Para sua segurança, essa senha não ficará salva em nossos servidores."}
                    show={showModal}
                    update={(e) => updatePassword(e)}
                    onHide={closeModalPassword}
                />
                <ModalText
                    show={showModalText}
                    onHide={modalTextClose}
                    text={"Certificado digital é um arquivo eletrônico que serve como identidade virtual para uma pessoa física ou jurídica. Ele serve para agilizar a assinatura conferindo legitimidade aos documentos digitais, que passam a possuir validade jurídica. Esse certificado deve ser emitido por uma Autoridade Certificadora vinculada ao ICP-Brasil"}
                    btnOk={false}
                />

                <Modal
                    show={uploadCertModal}
                    onHide={() => fecharUploadCertModal()}
                    align="center"
                    justify="center"
                    responsive
                    width="480px"
                >
                    <ModalTitle>Upload do certificado digital</ModalTitle>

                    <ModalBody>
                        <PlanilhaDropzone
                            descricao="O upload do certificado é necessário caso deseje assinar sua receita digitalmente."
                            chamada="Arraste o certificado aqui"
                            legenda="PFX de até 3 MB"
                            accept={CERTIFICADO_ACCEPT}
                            // O cartao do arquivo espera {nome, tamanho,
                            // extensao}, e nao o File cru: sem isso a bolinha
                            // verde e o nome saem em branco.
                            arquivo={
                                certificadoSelecionado
                                    ? {
                                        nome: certificadoSelecionado.name,
                                        tamanho: formatFileSize(certificadoSelecionado.size),
                                        extensao: certificadoSelecionado.name.split(".").pop() || "",
                                    }
                                    : null
                            }
                            onSelect={(arquivo) => setCertificadoSelecionado(arquivo)}
                            onRemove={() => setCertificadoSelecionado(null)}
                            onReject={(motivo) => notificaErro(motivo)}
                        />

                        <div style={{ width: "100%", marginTop: "16px" }}>
                            <Button
                                width='100%'
                                height='50px'
                                value='SALVAR'
                                outline={false}
                                disabled={!certificadoSelecionado}
                                onClick={() => salvarCertificadoSelecionado()}
                                loading={false}
                            />
                        </div>
                    </ModalBody>
                </Modal>

                <Modal
                    show={signatureModal}
                    onHide={() => setSignatureModal(false)}
                    align="center"
                    justify="center"
                    responsive
                    width="480px"
                >
                    <ModalTitle>Cadastrar assinatura eletrônica</ModalTitle>

                    <ModalBody>
                        <InputSign
                            sign={sign}
                            update={(e) => saveSign(e)}
                        />
                    </ModalBody>
                </Modal>
            </FormButtonContainer>


            <ModalAlert
                show={showModalBlock}
                onHide={false}
            >
                <h4 style={{
                    textAlign: 'center'
                }}>Essa é uma função exclusiva para clientes AgroReceita</h4>

                <p style={{
                    textAlign: 'center',
                    marginTop: '20px',
                }}>
                    Para não comprometer o controle de suas receitas agronômicas essa função só pode ser utilizada nos planos Light e Pro. Entre em contato com nosso suporte e faça o upgrade do seu plano para desbloquear esse recurso.
                </p>

                <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                    <Button
                        width='296px'
                        height='50px'
                        value='ENTENDI'
                        outline={false}
                        disabled={false}
                        onClick={() => setShowModalBlock(false)}
                        loading={false}
                    />
                </div>
            </ModalAlert>

            <ModalAlert
                show={showDisabledCad}
                onHide={() => setShowDisabledCad(false)}
                size='md'
            >
                <h4 style={{
                    fontSize: '16px',
                    textAlign: 'center'
                }}>Limite de cadastros atingido!</h4>

                <p style={{
                    textAlign: 'center',
                    marginTop: '20px',
                    fontSize: '13px',
                    letterSpacing: '0px'
                }}>
                    Adquira mais licenças para adicionar novos responsáveis técnicos!
                </p>

                <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                    <Button
                        width='296px'
                        height='50px'
                        value='ADQUIRIR MAIS LICENÇAS'
                        outline={false}
                        disabled={false}
                        onClick={() => window.location = '/plano/edit'}
                        loading={false}
                    />
                </div>
            </ModalAlert>
        </>
    );
};
export default Agronomo;
